import { Badge } from "primereact/badge";
import React from "react";

const statusBodyTemplate = (rowData) => {
  const statusBody = [
    {
      status: "Aberto",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#9E3131", color: "white" }}
          value={rowData.status}
        />
      )
    },
    {
      status: "Em andamento",
      content: (
        <Badge
          style={{ minWidth: 100, color: "white" }}
          severity={"warning"}
          value={rowData.status}
        />
      )
    },
    {
      status: "Aguardando técnico",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#1976D2", color: "white" }}
          value={rowData.status}
        />
      )
    },
    {
      status: "Pendente peça",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#FF8B00", color: "white" }}
          value={"Aguardando peça"}
        />
      )
    },
    {
      status: "Equipamento liberado",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#2E7D32", color: "white" }}
          value={rowData.status}
        />
      )
    },
    {
      status: "Fechado",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#003B17", color: "white" }}
          value={rowData.status}
        />
      )
    },
    {
      status: "Cancelado",
      content: (
        <Badge
          style={{ minWidth: 100, backgroundColor: "#6C757D", color: "white" }}
          value={rowData.status}
        />
      )
    }
  ];

  const body = statusBody.find((status) => status.status === rowData.status);

  if (body) return body.content;

  return (
    <Badge
      style={{ minWidth: 100, backgroundColor: "gray", color: "white" }}
      value={rowData.status}
    />
  );
};

// "Equipamento liberado" é o status que libera o fechamento da OS no
// backend (ver ServiceOrderRepository::assertCanBeClosed). Usada pelo botão
// de alerta "pronta pra fechar" na coluna de Ações (ver pages/ServiceOrder/Table).
export const isEquipmentLiberado = (rowData) =>
  rowData.status === "Equipamento liberado";

// Gravado no backend (ServiceOrder.in_progress_by) toda vez que a OS entra
// em "Em andamento" — é o técnico que apertou "Iniciar relatório" por
// último, exato (não é mais aproximação pelo relatório mais recente).
export const technicianBodyTemplate = (rowData) =>
  rowData.in_progress_by?.name || "-";

const renderPatSerie = (rowData) => {
  if (rowData.service_type === "A faturar") {
    return rowData.equipment.serial_number;
  }
  if (rowData.equipment) {
    return rowData.equipment.pat;
  }
};

const renderServiceNumber = (rowData) => {
  const date = rowData.workshop_received_date || rowData.created_at;
  const year = date?.split("-")[0];
  return year + "." + rowData.service_number;
};

const dataConstruct = (rowData) => {
  const data = rowData.workshop_received_date;

  if (!data) {
    return "";
  }

  let splitT = data.split("T");
  let split = splitT[0].split("-");
  return split[2] + "/" + split[1] + "/" + split[0];
};

const dataCreatedAt = (rowData) => {
  const data = new Date(rowData.created_at);
  const dia = data.getDate();
  const mes = data.getMonth() + 1;
  const ano = data.getFullYear();
  const diaFormatado = dia < 10 ? `0${dia}` : dia;
  const mesFormatado = mes < 10 ? `0${mes}` : mes;
  const dataFormatada = `${diaFormatado}/${mesFormatado}/${ano}`;
  return dataFormatada;
};

const dataConstructOSDate = (rowData) => {
  const data = rowData.closed_os_date;

  if (!data) {
    return "";
  }

  let splitT = data.split("T");
  let split = splitT[0].split("-");
  return split[2] + "/" + split[1] + "/" + split[0];
};

export const tableData = [
  {
    name: "service_number",
    header: "Nº da OS",
    headerStyle: { width: "10rem" },
    body: renderServiceNumber,
    sortable: true
  },
  {
    name: "company.name",
    header: "Empresa",
    sortable: true
  },
  {
    name: "error_description",
    header: "Descrição do problema",
    sortable: true
  },
  {
    name: "equipment.serial_number",
    header: "PAT/SERIE",
    sortable: true,
    body: renderPatSerie
  },
  {
    name: "created_at",
    header: "Criado em",
    sortable: true,
    body: dataCreatedAt
  },
  {
    name: "workshop_received_date",
    header: "Data de recebimento",
    body: dataConstruct,
    sortable: true
  },
  {
    name: "closed_os_date",
    header: "Data de fechamento",
    body: dataConstructOSDate,
    sortable: true
  },
  {
    name: "status",
    header: "Status",
    body: statusBodyTemplate,
    sortable: true
  },
  {
    name: "Ações",
    header: "Ações",
    sortable: false
  }
];
